import {CashBoxStatus} from "./CashBoxStatus";

export const CashBoxStatusColors: Record<CashBoxStatus, "primary" | "secondary" | "info" | "warning" | "error" | "success" | "default"> = {
  [CashBoxStatus.IN_PROGRESS]: "primary",
  [CashBoxStatus.SENT]: "secondary",
  [CashBoxStatus.CONFIRM]: "info",
  [CashBoxStatus.REPORT_SUBMITTED]: "warning",
  [CashBoxStatus.TO_FIX]: "error",
  [CashBoxStatus.CLOSE]: "success",
};

